import React, { forwardRef } from "react";
import { Box, Typography } from "@mui/material";
import MarMonthlyTable from "../../../resident/marMonthlyTable";
import DocumentSignatureSection from "../../../resident/common/documentSignatureSection";

const PrintableMar = forwardRef(
    ({ meds, doses, selectedDate, resident, signatureRoles = [], reportSignatures = {} }, ref) => {
        if (!selectedDate) return null;

        const year = selectedDate.getFullYear();
        const monthName = selectedDate.toLocaleString("default", { month: "long" });
        const residentDisplayName =
            [resident?.firstName, resident?.lastName].filter(Boolean).join(" ").trim() ||
            `Resident #${resident?.id || ""}`;
        const printedAt = new Date().toLocaleString();

        return (
            <Box ref={ref} sx={{ p: 3, width: "1600px" }}>
                <Box
                    className="print-fixed-header"
                    sx={{
                        display: "none",
                        "@media print": {
                            display: "block"
                        }
                    }}
                >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Form: Medication Administration Record (MAR) | Resident: {residentDisplayName} | Month: {monthName} {year} | Printed: {printedAt}
                    </Typography>
                </Box>
                <Box className="print-content-offset">

                {/* ---------------- TITLE ---------------- */}
                <Typography
                    variant="h5"
                    sx={{ textAlign: "center", mb: 2, fontWeight: 700 }}
                >
                    Medication Administration Record (MAR)
                </Typography>

                {/* ---------------- HEADER (PRINT-SAFE) ---------------- */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        border: "1px solid #444",
                        p: 1,
                        mb: 2,
                        "@media print": {
                            display: "block",
                            breakInside: "avoid"
                        }
                    }}
                >

                    {/* LEFT SECTION — RESIDENT */}
                    <Box
                        sx={{
                            width: "48%",
                            "@media print": {
                                width: "100%",
                                marginBottom: "6px"
                            }
                        }}
                    >
                        <Typography sx={{ fontWeight: 600 }}>Resident Name:</Typography>
                        <Typography>
                            {resident?.firstName} {resident?.lastName}
                        </Typography>
                    </Box>

                    {/* RIGHT SECTION — MONTH/YEAR */}
                    <Box
                        sx={{
                            width: "48%",
                            "@media print": {
                                width: "100%",
                                marginBottom: "6px"
                            }
                        }}
                    >
                        <Typography sx={{ fontWeight: 600 }}>Month / Year:</Typography>
                        <Typography>
                            {monthName} {year}
                        </Typography>
                    </Box>
                </Box>

                {/* ---------------- MONTHLY TABLE (LANDSCAPE) ---------------- */}
                <MarMonthlyTable
                    meds={meds}
                    doses={doses}
                    selectedDate={selectedDate}
                    forPrint={true}
                />
                <DocumentSignatureSection
                    title="MAR Report Signatures"
                    roles={signatureRoles}
                    signatures={reportSignatures}
                    showEditor={false}
                    showPrintBlock
                    printTopMargin={3}
                />
                </Box>
            </Box>
        );
    }
);

export default PrintableMar;
